// Campaign / UTM / focus parameter system.
// Use via the `useCampaign` hook (see /hooks/useCampaign.js).
//
// Conventions:
//   ?focus=adult | kids | taster | online | battles | merch | bookings
//        → scrolls/highlights matching <section data-focus="adult"> on the page
//   ?intent=taster | main | enquiry | waitlist
//        → switches active tab / form on pages that support it
//   ?utm_source=… ?utm_medium=… ?utm_campaign=… ?utm_term=… ?utm_content=…
//        → captured into sessionStorage and attached to every analytics event

const UTM_KEYS = ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content"];
const STORAGE_KEY = "usdd_campaign";

export function readCampaignFromUrl(search = window.location.search) {
  const params = new URLSearchParams(search);
  const utm = {};
  UTM_KEYS.forEach((k) => {
    const v = params.get(k);
    if (v) utm[k] = v;
  });
  return {
    focus: params.get("focus") || null,
    intent: params.get("intent") || null,
    ref: params.get("ref") || null,
    utm,
  };
}

export function persistCampaign(campaign) {
  if (typeof window === "undefined") return;
  try {
    const existing = JSON.parse(sessionStorage.getItem(STORAGE_KEY) || "{}");
    const merged = {
      ...existing,
      ...campaign,
      utm: { ...(existing.utm || {}), ...(campaign.utm || {}) },
      landed_at: existing.landed_at || new Date().toISOString(),
      path: existing.path || window.location.pathname,
      landing_referrer: existing.landing_referrer || (typeof document !== "undefined" ? document.referrer || null : null),
    };
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(merged));
    return merged;
  } catch {
    return campaign;
  }
}

export function getStoredCampaign() {
  if (typeof window === "undefined") return {};
  try {
    return JSON.parse(sessionStorage.getItem(STORAGE_KEY) || "{}");
  } catch {
    return {};
  }
}
